export enum YealinkExpansionModel {
  'yealink-exp43' = 'Yealink EXP43',
}

export type YealinkExpansionModelCode = keyof typeof YealinkExpansionModel;
